/**
 * Usuário interno da AiNumera (e-mail @ainumera.com). Usado para liberar funcionalidades ainda
 * não disponíveis aos clientes — ex.: Importar Razão Universal (DEVN3-600).
 */
export function isUsuarioInterno(email?: string | null): boolean {
  return !!email && email.trim().toLowerCase().endsWith('@ainumera.com');
}
